<template>
  <div v-if="templates">
    <b-input-group>
      <multiselect v-model="selectedTemplate"
                   :class="{'invalid': invalid}"
                   class="form-control template-selector"
                   :placeholder="$t('components.template_selector.select')"
                   label="name"
                   track-by="name"
                   :options="templates"
                   :option-height="80"
                   :allow-empty="false"
                   deselectLabel=""
                   :tagPlaceholder="$t('components.multiselect.tagPlaceholder')"
                   :selectLabel="$t('components.multiselect.selectLabel')"
                   @remove="handleRemove"
                   @select="handleSelectedTemplate"
      >
      </multiselect>
      <b-input-group-append>
        <b-button variant="success"
                  class="apn-btn"
                  :disabled="!selectedTemplate"
                  :class="{'invalid': invalid}"
                  @click="handleClick">
          <i class="mdi mdi-eye"></i>
          {{ $t('components.template_selector.show') }}
        </b-button>
      </b-input-group-append>
    </b-input-group>

  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {campaignMethods, campaignComputed} from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  name: "TemplateSelector",
  props: ['templates', 'invalid', 'defaultTemplate'],
  components: {Multiselect},
  data() {
    return {
      selectedTemplate: null,
    }
  },
  watch: {
    defaultTemplate(val) {
      this.selectedTemplate = val
    },
    selectedTemplate(newVal) {
      const currentTemplateType = newVal?.type
      this.setTemplateType({type: currentTemplateType})
    }
  },
  computed: {
    ...campaignComputed
  },
  methods: {
    ...campaignMethods,
    handleSelectedTemplate(e) {
      this.$emit('selectedTemplate', e)
    },
    handleRemove(e) {
      this.$emit('remove', e.id)
    },
    handleClick() {
      if (!this.isOfficialType) {
        this.$helpers.openNewTab('email.design', {emailID: this.selectedTemplate.id})
      }
      Swal.fire({
        imageUrl: this.templateTypeOptions[this.selectedTemplateType].img,
        width: 620,
        imageWidth: 620,
        imageHeight: 620,
        imageAlt: this.selectedTemplateType,
      })
    }
  },
}
</script>

<style scoped>
.template-selector {
  padding: 0;
  border: none;
}

.apn-btn {
  border-radius: 0 0.25em 0.25em 0 !important;
  height: 36px
}

/deep/ .multiselect__tags {
  border-radius: 0.25rem 0 0 0.25rem !important;
}

.invalid {
  border-color: #f46a6a !important;
}

/deep/ .multiselect {
  max-height: 36px !important;
}

/deep/ .multiselect__tags {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/ .invalid .multiselect__tags {
  border-color: #f46a6a !important;
}

/deep/ .multiselect__placeholder {
  white-space: nowrap;
}
</style>